// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"318":"b98ec089ee3c4d068ac2","730":"48358ccbea32b185595b"}[chunkId] + ".js";
};